import { useEffect, useState } from 'react';

//CSS
import './BannersShop.css';
import { bannerList } from '../../../actions/admin/banner';
import { simpleConfirmDialog } from '../../../actions/swal_msg';

import BannerCard from './BannerCard';
import BannerShopDialog from './BannerShopDialog';

//MUI
import { Container, Grid, Typography } from '@mui/material';

const BannersShop = () => {
    const [anchorEl, setAnchorEl] = useState({
        anchorEl1: null,
        anchorEl3: null,
        anchorEl2: null
    });
    const { anchorEl1, anchorEl2, anchorEl3 } = anchorEl;
    const open1 = Boolean(anchorEl1);
    const open2 = Boolean(anchorEl2);
    const open3 = Boolean(anchorEl3);

    // imágenes de banner
    const [banner, setBanner] = useState({
        type: 'desktop', // vista de banner
        images: [], // nuevas imágenes
        desktop: {
            _id: '',
            images: []
        },
        tablet: {
            _id: '',
            images: []
        },
        mobile: {
            _id: '',
            images: []
        },
        backup: {
            desktop: [],
            tablet: [],
            mobile: []
        }
    });
    const { desktop, tablet, mobile, type, images } = banner;

    // imágenes removidas
    const [deletedImages, setDeletedImages] = useState({
        desktop: [],
        tablet: [],
        mobile: []
    });

    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        bannerList(setBanner);
    }, []);
    
    const handleClick = (bannerType, anchor) => (event) => {
        setBanner({ ...banner, type: bannerType });
        setAnchorEl(({ ...anchorEl, [anchor]: event.currentTarget }));
    };
    const handleClose = anchor => () => {
        setAnchorEl((e) => ({ ...e, [anchor]: null }));
    };

    // abrir modal
    const handleClickOpenDialog = anchor => () => {
        setOpenDialog(true);
        setAnchorEl((e) => ({ ...e, [anchor]: null }));
    };

    const handleCloseDialog = async () => {
        if (images.length > 0 || deletedImages[type].length > 0) {
            if (await simpleConfirmDialog('Tiene cambios sin guardar, ¿descartar?', 'Sí, salir')) {
                setDeletedImages(e => ({ ...e, [type]: [] }));
                setBanner(e => ({
                    ...e, images: [], [type]: {
                        ...e[type], images: JSON.parse(JSON.stringify(e.backup[type]))
                    }
                }));
                setOpenDialog(false);
            }
        } else
            setOpenDialog(false);
    };

    const handleInputChange = (banner_type, imgId) => ({ target: { value } }) => {
        setBanner(e => ({
            ...e, [banner_type]: {
                ...e[banner_type], images: e[banner_type].images.map(
                    u => u.imgId === imgId ? { ...u, url: value } : u
                )
            }
        }))
    };

    return (
        <>
            <Container maxWidth='xl' sx={{ mb: 5, mt: '90px' }}>
                {/* Titulo y botón impulso de producto */}
                <Typography variant='h4' sx={{ fontWeight: 'light' }} gutterBottom>Banners tienda en linea</Typography>

                {/* Sección para visualizar y editar sección de banners */}
                <Grid container spacing={4} sx={{ mt: '10px' }}>
                    <BannerCard
                        type={'desktop'}
                        images={desktop.images}
                        setBanner={setBanner}
                        open={open1}
                        typeTxt={'escritorio'}
                        anchorEl={anchorEl1}
                        anchorTxt={'anchorEl1'}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        handleInputChange={handleInputChange}
                        handleClickOpenDialog={handleClickOpenDialog}
                    />

                    <BannerCard
                        type={'tablet'}
                        images={tablet.images}
                        setBanner={setBanner}
                        open={open2}
                        typeTxt={'tableta'}
                        anchorEl={anchorEl2}
                        anchorTxt={'anchorEl2'}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        handleInputChange={handleInputChange}
                        handleClickOpenDialog={handleClickOpenDialog}
                    />

                    <BannerCard
                        type={'mobile'}
                        images={mobile.images}
                        setBanner={setBanner}
                        open={open3}
                        typeTxt={'celular'}
                        anchorEl={anchorEl3}
                        anchorTxt={'anchorEl3'}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        handleInputChange={handleInputChange}
                        handleClickOpenDialog={handleClickOpenDialog}
                    />
                </Grid>
                {/* Fin sección para visualizar y editar sección de banners  */}
            </Container>

            <BannerShopDialog
                handleCloseDialog={ handleCloseDialog }
                openDialog={ openDialog }
                type={ type }
                banner={ banner }
                setBanner={ setBanner }
                deletedImages={ deletedImages }
                setDeletedImages={ setDeletedImages }
            />
        </>
    );
};

export default BannersShop;